import { render, staticRenderFns } from "./Attachment.vue?vue&type=template&id=33bba6c8&scoped=true"
import script from "./Attachment.vue?vue&type=script&lang=js"
export * from "./Attachment.vue?vue&type=script&lang=js"
import style0 from "./Attachment.vue?vue&type=style&index=0&id=33bba6c8&prod&scoped=true&lang=css"
import style1 from "./Attachment.vue?vue&type=style&index=1&id=33bba6c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bba6c8",
  null
  
)

export default component.exports